import { CustomOffsetMessageType, CustomOffsetRecord, OffsetOption } from './';

export function customOffsetToOption(
  offset: CustomOffsetRecord,
  messageType: CustomOffsetMessageType,
): OffsetOption {
  const short = formatDuration(offset.offset);
  let labelSuffix = '';
  if (messageType === 'confirmation') labelSuffix = ' after saving';
  else if (messageType === 'reminder') labelSuffix = ' before the event';
  else if (messageType === 'follow_up') labelSuffix = ' after the event';
  const option: OffsetOption = {
    value: offset.offset.toString(),
    label: `${short}${labelSuffix}`,
    short,
    id: offset.id,
    is_custom: true,
  };
  return option;
}

function formatDuration(ms: number): string {
  const totalMinutes = Math.floor(ms / 60000);
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;
  const parts: string[] = [];
  if (days > 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);
  if (hours > 0) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
  if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
  if (parts.length === 0) return '0 minutes';
  return parts.length === 1
    ? parts[0]
    : parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1];
}
